export const useNewsletter = () => {
  const { t } = useI18n()
  const form = ref({
    email: {
      value: '',
      error: '',
    },
    checkbox: {
      value: false,
      error: '',
    },
    name: {
      value: '',
      error: '',
    },
  })
      
  const validateEmail = () => {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let input = form.value.email
    let result = re.test(String(input.value).toLowerCase())
    if (!result) {
      if (input.value === '') {
        input.error = t('form.error.input.empty')
      } else {
        input.error = t('form.error.input.email')
      }
    } else {
      input.error = ''
    }
  }
      
  const validateCheckbox = () => {
    let input = form.value.checkbox
      
    if (input.value) {
      input.error = ''
    } else {
      input.error = t('form.error.input.checkbox')
    }
  }

  const validateName = () => {
    let input = form.value.name
    input.error = input.value.trim() ? '' : input.error = t('form.error.input.empty')
  }
      
  const submitForm = (e: HTMLInputElement) => {
    validateEmail()
    validateCheckbox()
    validateName()
      
    const values = Object.values(form.value)
    const hasError = values.some(({ error }) => error !== '')
      
    if (!hasError) e.target.submit()
  }

  return {
    submitForm,
    validateEmail,
    validateCheckbox,
    form,
  }
}
